export const backendBaseUrl = "https://dicom-dashboard.remidio.com";
export const apiToken =
  "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI2MWZmODJhZi1kZGNhLTQ0YmYtOGRiOC04NjM3MmNkYjMxOGUiLCJpc3MiOiJodHRwczovL2RpY29tLXNlY3VyZS1zdGFnaW5nLmFwcHNwb3QuY29tIiwic3ViIjoiNTYzMjQ5OTA4MjMzMDExMiIsImlhdCI6MTU4NTIzMzE3NH0.1qgXS7Wo0_19A1iPqyZmhvKOmT1trb277lhP9iStdjc";
